import type { FaireProductEntity } from "../../entity_types/product";

export const p_vsutu64vja: FaireProductEntity = {
  token: "p_vsutu64vja",
  type: "product",
  name: "Algae Cooking Oil – The Future of Healthy, Chef-Driven Oils",
  brandToken: "b_wzx8v3srb4",
  brandName: "Algae Cooking Club",
  imageUrl:
    "https://cdn.faire.com/fastly/926b0331734e1c7533529c9f49e4a281b1ebd549f3a7b2b5c8290e2a758b33e3.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9caff06f9c14c63ad3e220ef9dafd7145dd887a54fdd7abb7db248a8774be85f.png",
    "https://cdn.faire.com/fastly/6f982c8e58341d81402cafef774a7cb5e4a7d87bd6f923cd4ffc189d85bd46d3.png",
    "https://cdn.faire.com/fastly/141e808b66c9ed0ef21d82c3fff31164829f743a5d1d4c0727fae9b241e79723.png",
    "https://cdn.faire.com/fastly/fa143127ccf851d3b60dd2106d58bad552df7132a9f9edcf5507ed9d2ea23491.png",
    "https://cdn.faire.com/fastly/2b28e18200346648d1cd9a1a086d5e22672f2793a09c338b4fe6cfa9a3638b0d.png",
    "https://cdn.faire.com/fastly/2cdbfb398460f64f6c4a65bf96a509e8f7cf98b029d77cb2a0b5351c38d4b317.png",
    "https://cdn.faire.com/fastly/2731f10a4e2c1041e48599030544b7b31934fb574df3eb18f5e754287c89819e.png",
  ],
  priceDollars: 10,
  description:
    "Experience the purity and versatility of chef-grade algae cooking oil, crafted for high-heat cooking, dressings, and more. Developed with Chef Daniel Humm and Eleven Madison Park, this premium oil offers a light buttery flavor that enhances dishes without overpowering them.\n\n✨ 𝐖𝐡𝐲 𝐇𝐨𝐦𝐞 𝐂𝐨𝐨𝐤𝐬 & 𝐂𝐡𝐞𝐟𝐬 𝐋𝐨𝐯𝐞 𝐈𝐭:\n• Highest Smoke Point (535°F) – 125°F higher than olive oil, unlocking crispy, tender textures\n• Enhances, Never Overpowers – A neutral, buttery finish perfect for cooking\n• Heart & Gut Healthy & Omega-9 Rich – 75% less saturated fat than avocado & olive oil. Lowest Omega-6 of Any Common Oil – Supports gut health by reducing inflammation\n• Sustainable Impact – Uses 1/10 the land & water & ½ the carbon footprint\n• 100% Seed Oil-Free – 3rd party tested! No blending, 100% seed-oil free\n\n🔥 𝐒𝐮𝐩𝐫𝐞𝐦𝐞𝐥𝐲 𝐕𝐞𝐫𝐬𝐚𝐭𝐢𝐥𝐞 – 𝐔𝐬𝐞 𝐈𝐭 𝐅𝐨𝐫:\n• Searing meats, seafood\n• Stir-frying, sautéing\n• Dressings, marinades & dips\n• Baking",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:55:16.373Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
